import React from 'react';
import { useLocation } from 'react-router-dom';
import { Exams } from './Exams';
const ExamsWrapper = (props) => {
  const location = useLocation();
  return <Exams location={location} {...props} />;
};

export default ExamsWrapper;
